// extracted by mini-css-extract-plugin
export var divider = "_py-0";
export var systemMessage = "_py-1";
export var systemMessageWrapper = "_py-2";